import React, { Component, Fragment } from "react";
import { logout } from "../../services/user";

export class Logout extends Component {
    componentDidMount() {
        logout()
            .then(res => {
                localStorage.removeItem("auth_token");
                localStorage.removeItem("user");
                localStorage.removeItem("user_steps");
                localStorage.removeItem("user_email");
                this.props.history.push("/");

            })
            .catch(error => {
                switch (error.response.status) {
                    case 422:
                        this.setState({ errors: error.response.data.errors });
                        break;
                    default:
                        this.context.state.handelError(error);
                        break;
                }
            });
    }
    render() {
        return <Fragment></Fragment>;
    }
}

export default Logout;



// WEBPACK FOOTER //
// ./src/components/auth/Logout.js